// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__H9llj","card":"Dashboard_card__1OQDM","cardContent":"Dashboard_cardContent__qTIWw","defectbutton":"Dashboard_defectbutton__UIPuC"};